import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type FamilyModel from 'frontend/models/family';
import type TagModel from 'frontend/models/tag';

export interface FamiliesTagsDisplayComponentArgs {
  families: FamilyModel[];
  tags: TagModel[];
}

interface FamiliesAndTags {
  id: string;
  type: 'families' | 'tags';
  name: string;
}

export default class FamiliesTagsDisplayComponent extends Component<FamiliesTagsDisplayComponentArgs> {
  @service declare router: RouterService;

  get familiesAndTags(): FamiliesAndTags[] {
    const families: FamiliesAndTags[] = this.args.families.map((family) => ({
      type: 'families',
      id: family.id,
      name: family.name,
    }));
    const tags: FamiliesAndTags[] = this.args.tags.map((tag) => ({
      type: 'tags',
      id: tag.id,
      name: tag.name,
    }));
    return [...families, ...tags];
  }

  get sizeFamiliesTagsMinusOne() {
    return this.familiesAndTags.length - 1;
  }

  @action
  async transitionToSearch(item: FamiliesAndTags, event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    await this.router.transitionTo('formations', {
      queryParams: { [item.type]: [item.id] },
    });
  }
}
